exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* stylelint-disable */\n\n/* ==========================================================================\n   Label\n   ========================================================================== */\n.label {\n  border: 1px solid transparent;\n  border-radius: 2px;\n  color: #fff;\n  font-family: Roboto;\n  font-weight: 600;\n  text-transform: uppercase;\n  display: inline-flex;\n  align-items: center; }\n\n/* Sizes\n   ========================================================================== */\n.label--size-small {\n  font-size: 11px;\n  line-height: 12px;\n  padding: 2px 5px; }\n\n.label--size-medium {\n  font-size: 12px;\n  line-height: 15px;\n  padding: 2px 5px; }\n\n.label--size-large {\n  font-size: 13px;\n  line-height: 15px;\n  padding: 4px 7px; }\n\n/* Types\n   ========================================================================== */\n.label--type-default {\n  background-color: #858484; }\n\n.label--type-instruction {\n  background-color: #25b8d2; }\n\n.label--type-light {\n  background-color: #ddd; }\n\n.label--type-active {\n  background-color: #6acb4c; }\n\n.label--type-inactive {\n  background-color: #f54545; }\n\n.label--type-warning {\n  background-color: #eca03e; }\n\n.label--type-info {\n  background: #834ba2; }\n\n.label--type-default-outlined {\n  color: #858484;\n  border-color: #858484;\n  background: #fff; }\n\n.label--type-instruction-outlined {\n  color: #fff;\n  border-color: #25b8d2;\n  background: #fff; }\n\n.label--type-light-outlined {\n  color: #ddd;\n  border-color: #ddd;\n  background: #fff; }\n\n.label--type-active-outlined {\n  color: #6acb4c;\n  border-color: #6acb4c;\n  background: #fff; }\n\n.label--type-inactive-outlined {\n  color: #f54545;\n  border-color: #f54545;\n  background: #fff; }\n\n.label--type-warning-outlined {\n  color: #eca03e;\n  border-color: #eca03e;\n  background: #fff; }\n\n.label--type-info-outlined {\n  color: #834ba2;\n  border-color: #834ba2;\n  background: #fff; }\n\n.label--type-default-link {\n  color: #858484; }\n\n.label--type-instruction-link {\n  color: #fff; }\n\n.label--type-light-link {\n  color: #ddd; }\n\n.label--type-active-link {\n  color: #6acb4c; }\n\n.label--type-inactive-link {\n  color: #f54545; }\n\n.label--type-warning-link {\n  color: #eca03e; }\n\n.label--type-info-link {\n  color: #834ba2; }\n", ""]);

// exports
exports.locals = {
	"color-groups": "base | colors | primary | semantic | chart",
	"colors-white": "#fff",
	"colors-red": "#f54545",
	"colors-green": "#6acb4c",
	"colors-body-color": "#363636",
	"colors-grey-90": "#444",
	"colors-grey-80": "#666",
	"colors-grey-70": "#858484",
	"colors-grey-60": "#a4a4a4",
	"colors-grey-50": "#c2c2c2",
	"colors-grey-40": "#ddd",
	"colors-grey-30": "#ececec",
	"colors-grey-20": "#f2f2f2",
	"colors-grey-10": "#f8f8f8",
	"colors-black": "#000",
	"base-brown-100": "#343230",
	"base-brown-80": "#474340",
	"base-brown-60": "#61554c",
	"base-brown-40": "#998673",
	"base-brown-20": "#c1aa95",
	"base-earth-100": "#bbb6af",
	"base-earth-80": "#c7c1b8",
	"base-earth-60": "#d7cebf",
	"base-earth-40": "#eae4db",
	"base-earth-20": "#e9e7db",
	"base-earth-10": "#f7f5eb",
	"primary-romantic-purple-base": "#834ba2",
	"primary-romantic-purple-dark": "#5a3770",
	"primary-romantic-purple-light": "#ab83c4",
	"primary-sky-blue-base": "#25b8d2",
	"primary-sky-blue-dark": "#1797ae",
	"primary-sky-blue-light": "#57d0dd",
	"primary-mint-base": "#3fc798",
	"primary-mint-dark": "#2cab7f",
	"primary-mint-light": "#79dbb5",
	"primary-grassy-base": "#96cb4c",
	"primary-grassy-dark": "#81a03c",
	"primary-grassy-light": "#b7dd7a",
	"primary-desert-sunset-base": "#eca03e",
	"primary-desert-sunset-dark": "#c2802a",
	"primary-desert-sunset-light": "#fbc75c",
	"primary-salmon-base": "#f57b45",
	"primary-salmon-dark": "#d45e2a",
	"primary-salmon-light": "#ef9a78",
	"semantic-color-primary": "#f57b45",
	"semantic-color-primary-hovered": "#d45e2a",
	"semantic-color-primary-active": "#ef9a78",
	"semantic-color-secondary": "#25b8d2",
	"semantic-color-secondary-hovered": "#1797ae",
	"semantic-color-secondary-active": "#57d0dd",
	"semantic-color-light": "#fff",
	"semantic-color-light-hovered": "#fff",
	"semantic-color-light-active": "#fff",
	"semantic-color-dark": "#f8f8f8",
	"semantic-color-dark-hovered": "#f2f2f2",
	"semantic-color-dark-active": "#f8f8f8",
	"semantic-color-error": "#f54545",
	"semantic-color-success": "#6acb4c",
	"semantic-color-warning": "#eca03e",
	"semantic-color-instruction": "#25b8d2",
	"semantic-color-info": "#834ba2",
	"semantic-color-hint": "#c2c2c2",
	"chart-first": "#25b8d2",
	"chart-second": "#f57b45",
	"chart-third": "#96cb4c",
	"chart-fourth": "#eca03e",
	"chart-fifth": "#3fc798",
	"chart-sixth": "#ab83c4",
	"chart-seventh": "#c1aa95",
	"chart-eighth": "#c2c2c2"
};